<script lang="ts">
    import { _ } from "svelte-i18n"
    import { deliveryTimeCodes } from "../../codes"

    export let product: Product
</script>

{#if product?.delivery_time}
    <div class="availability status{product.delivery_time}">
        <span class="status"></span>
        <!-- TODO lang -->
        <span class="description"
            >{deliveryTimeCodes[product.delivery_time] &&
                deliveryTimeCodes[product.delivery_time].value +
                    " " +
                    $_(deliveryTimeCodes[product.delivery_time].text)}
            {$_("product.delivery-time")}</span
        >
    </div>
{/if}
